import React, { useContext, useEffect, useState } from "react";
import tkm from '../../Images/tkm.png'
import eng from '../../Images/english.png'
import ru from '../../Images/russian.jpg'
import {
    DarkModeOutlined,
    LightModeOutlined,
    WbSunnyOutlined,
    DateRange,
    PersonOutline
} from "@mui/icons-material";
import { Context } from "../../Store/context";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { Link } from "react-router-dom";


const Navbar = () => {
    const { i18n, t } = useTranslation();
    const { darkMode, setDarkMode } = useContext(Context)
    var [date, setDate] = useState(new Date());
    const [weather, setWeather] = useState(null);


    useEffect(() => {
        const fetchWeather = async () => {
            try {
                const result = await axios.get('https://meteo.gov.tm/api/current-weather');
                const ashgabatWeather = result.data.data.find(e => e.place === 'Aşgabat');
                if (ashgabatWeather) {
                    setWeather(ashgabatWeather);
                }
            } catch (error) {

            }
        };
        fetchWeather();
    }, []);


    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    useEffect(() => {
        var timer = setInterval(() => setDate(new Date()), 1000)
        return function cleanup() {
            clearInterval(timer)
        }
    });

    const toggleDarkMode = () => {
        setDarkMode(!darkMode);
    };


    return (
        <div className="bg-blueOpacity w-full py-2 text-sm 
                        flex justify-between gap-2 px-4
                        xxl:px-12 xxxl:px-32 xxxxl:px-64 
                        xxxxxl:px-[400px] xxxxxxl:px-[650px] 
                        xxxxxxxl:px-[1600px] xxxxxxxxl:px-[2400px]"
        >
            <ul className="flex gap-4 items-center text-[12px]">
                <li>
                    <ul className="flex gap-4">
                        <li className="hidden lg:navbar-top-list">
                            <DateRange style={{ fontSize: '15px' }} />
                            {date.toLocaleDateString()}
                        </li>
                        <li className="navbar-top-list">
                            {weather ? (
                                <>
                                    <WbSunnyOutlined style={{ fontSize: '16px' }} />
                                    {`${weather.temperature}° Aşgabat`}
                                </>
                            ) : (
                                ''
                            )}
                        </li>
                    </ul>
                </li>
                <li className="navbar-top-list cursor-pointer z-[50]" onClick={toggleDarkMode}>
                    {darkMode ?
                        <LightModeOutlined style={{ fontSize: '16px' }} />
                        :
                        <DarkModeOutlined style={{ fontSize: '16px' }} />
                    }
                    <p className="hidden lg:block">
                    {darkMode ? `${t('lightmode')}` : `${t('darkmode')}`}
                    </p> 
                </li>
                <Link to='/auth/registration'
                    className="flex items-center text-white 
                               gap-1 text-[12px] mr-2 z-[50]">
                    <PersonOutline style={{ fontSize: '16px' }} />
                    <p className="hidden lg:block">{t('sign_in')}</p>
                </Link>
            </ul>
            <div className="flex gap-4 justify-end items-center z-[10]">
                <img
                    src={tkm}
                    className="w-[20px] h-[14px] cursor-pointer"
                    alt="turkmen"
                    onClick={() => changeLanguage('tm')}
                />
                <img
                    src={eng}
                    className="w-[20px] h-[14px] cursor-pointer"
                    alt="english"
                    onClick={() => changeLanguage('en')}
                />
                <img
                    src={ru}
                    className="w-[20px] h-[14px] cursor-pointer"
                    alt="russian"
                    onClick={() => changeLanguage('ru')}
                />
            </div>
        </div>
    )
}

export default Navbar;